import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const icon: SxStyle = {
  color: (p) => p.palette.grey[400],
};
